import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'UIComponents/elements/headings';
import UIModal from 'UIComponents/dialog/UIModal';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentViewToOptInType = {
  EVENT_ENROLLMENT_FROM_SEGMENTATION_FILTERS: 'optOut',
  LIST_ENROLLMENT: 'optIn',
  SELECTABLE_ENROLLMENT: 'select',
  SCHEDULED_ENROLLMENT: 'schedule'
};
const ExistingTriggersOptModal = ({
  view,
  onConfirm,
  onReject
}) => {
  const type = EnrollmentViewToOptInType[view];
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "success",
    "data-test-id": "trigger-selection-confirm-change-modal",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `automation-ui-enrollment.redesign.existingTriggersModal.${type}.title`
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onReject,
        "data-test-id": "trigger-selection-dialog-close"
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `automation-ui-enrollment.redesign.existingTriggersModal.${type}.description`
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: onConfirm,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `automation-ui-enrollment.redesign.existingTriggersModal.${type}.confirm`
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: onReject,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.existingTriggersModal.cancel"
        })
      })]
    })]
  });
};
export default ExistingTriggersOptModal;